import {useRef, useEffect} from 'react';

export const VIEWS = {
  'imports': 'imports',
  'cd': 'cd',
};

export const FILLER_STATUS = {
  'ordered_japan': 'ordered_japan',
  'list_bill_ordered': 'list_bill_ordered',
};

export const useInterval = (callback, delay) => {
  const savedCallback = useRef();

  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  useEffect(() => {
    function tick() {
      savedCallback.current();
    }
    let id = setInterval(tick, delay);
    return () => clearInterval(id);
  }, [delay]);
};
